import { KReachOut } from "./KReachOut"

const config = new KReachOut({
    id: "knymbus-73y326",
    type: "contact"
})

export default config 